module.exports = __webpack_public_path__ + "img/zeitleiste-zuklappen-gruen2.3e5d9e5b.svg";